import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IAssets } from '../types';

interface Props {
  userData: IAssets;
}

export const AssetsCard = ({ userData }: Props) => {
  const fields = [
    Strings.assets.purchaseDate,
    Strings.assets.serialNumber,
    Strings.assets.cost,
    Strings.assets.manufacturer,
    Strings.assets.warranty,
    Strings.assets.condition,
    Strings.assets.gst,
    Strings.assets.supplier,
  ];
  const data = [
    userData?.purchaseDate ?? 'NA',
    userData?.serialNumber ?? 'NA',
    userData?.cost ?? 'NA',
    userData?.manufacturer ?? 'NA',
    userData?.warranty ?? 'NA',
    userData?.condition ?? 'NA',
    userData?.gst || 'NA',
    userData?.supplier || 'NA',
  ];
  return <ProfileCard fields={fields} data={data} desc={userData?.description} columnCount={2} />;
};
